/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-bill-item.reducer';

export const PharmacyBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyBillItemEntity = useAppSelector(state => state.pharmacyBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.detail.title">PharmacyBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="qty">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.qty">Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.qty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.lastupdated}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.discount}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.paidAmount}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyBillItemEntity.taxCode}</dd>
          <dt>
            <span id="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.cessAmount">Cess Amount</Translate>
            </span>
            <UncontrolledTooltip target="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.help.cessAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyBillItemEntity.cessAmount}</dd>
          <dt>
            <span id="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.exempted">Exempted</Translate>
            </span>
            <UncontrolledTooltip target="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.help.exempted" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyBillItemEntity.exempted ? 'true' : 'false'}</dd>
          <dt>
            <span id="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.freeQty">Free Qty</Translate>
            </span>
            <UncontrolledTooltip target="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.help.freeQty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyBillItemEntity.freeQty}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyBillItemEntity.pharmacyStock ? pharmacyBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.pharmacyBill">Pharmacy Bill</Translate>
          </dt>
          <dd>{pharmacyBillItemEntity.pharmacyBill ? pharmacyBillItemEntity.pharmacyBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.uqcType">Uqc Type</Translate>
          </dt>
          <dd>{pharmacyBillItemEntity.uqcType ? pharmacyBillItemEntity.uqcType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{pharmacyBillItemEntity.scheme ? pharmacyBillItemEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-bill-item/${pharmacyBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyBillItemDetail;
